module.exports = __webpack_public_path__ + "static/img/YYMM.e38bfe4.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/YYMM.png
// module id = JktF
// module chunks = 1